import React from "react";

const Enterprise = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill" d="M31.09 28.063H34v2.883H2v-2.883h2.91V6.441c0-.382.152-.748.425-1.019.273-.27.643-.422 1.029-.422h14.545c.386 0 .756.152 1.029.422.272.27.426.637.426 1.02v21.621h2.909V13.65h4.363c.386 0 .756.152 1.029.422.273.27.426.637.426 1.02v12.972zM10.728 16.532v2.882h5.819v-2.883h-5.819zm0-5.766v2.883h5.819v-2.883h-5.819z"
          fill={fill}
      />
    </svg>
);

export default Enterprise;
